import {
  SET_VEHICLE_NUMBER,
  IS_SME,
  SET_VEHICLE_DETAILS,
  UPDATE_VEHICLE_DETAILS,
  SET_POLICY_DETAILS,
  SET_PROPOSAL_DETAILS,
  SET_PAYMENT_METHOD,
  GET_VEHICLE_DETAILS,
  REMOVE_VEHICLE,
  UPDATE_SINGLE_VEHICLE_DETAILS,
  SET_DRIVER,
  REMOVE_DRIVER,
  CHANGE_DEDUCTABLE,
  RESET,
  TAWUNIYA_LEAD
 } from "../constants/motor";
 
 import * as actions from "../constants/motor";
 import { data } from "jquery";
 
 const initialState = {
  number: "",
  isSme: false,
  isPaymentFailed: false,
  vehicles: [],
  tempVehicles: [],
  drivers: [],
  defaultValues: null,
  policyDetails: null,
  proposalDetails: null,
  paymentMethod: false,
  activeProgram: null,
  activeVehicle: null,
  carsFeatures: {},
  personalFormDetails: {
   nationalId: "",
   yob: "",
   prefixMobile: "+966",
   mobile: "",
   isSME: false,
   crNumber: "",
  },
  driverRegistered: {
    mobile: null,
    isDriverRegistered: false,
    isDriverSelected: false,
   },
  customerDetails:  {},
  quotationRequest: {},
  quotationDetails: {},
  applicationDetailsForms: {},
  applicationDetailsStatus: false,
  tmx: null,
  tmxVehicleDetails: null,
  quotationData: null,
  changeDeductable: 0,
  isleadGeneratation:false,
  otp:"",
  proposalPrice:"",
  tawnLead:false,
 };
 
 export default function motorReducer(state = initialState, action) {
  switch (action.type) {
   case actions.SET_TEMP_VEHICLES_ARR:
    return { ...state, tempVehicles: action.payload };
   case actions.UPDATE_FORMS_VALUES:
    return { ...state, applicationDetailsForms: action.payload };
    case actions.PAYMENTFAILED:
    return { ...state, isPaymentFailed: action.payload };
   case actions.UPDATE_FORMS_STATUS:
    return { ...state, applicationDetailsStatus: action.payload };
    case TAWUNIYA_LEAD:
      return {
       ...state,
       tawnLead: action.payload,
      };
   case actions.UPDATE_QUOTATION_REQUEST:
    return { ...state, quotationRequest: action.payload };
   case actions.SET_QUOTATION:
    return { ...state, quotationDetails: action.payload };
   case actions.SET_OTP:
    return { ...state, AppOTP: action.payload };
   case actions.SET_SELECTED_VEHICLE:
    return { ...state, appSelectedVehicle: action.payload };
   case SET_VEHICLE_NUMBER:
    return { ...state, number: action.payload };
   case SET_DRIVER:
    return { ...state, drivers: [...state.drivers, action.payload] };
   case actions.UPDATE_LOCAL_DRIVER:
    let drivers = [];
    const existDriver = state.drivers.filter((driver) => driver.IDNO === action.payload.IDNO);
    if (existDriver.length) {
     drivers = state.drivers.map((driver) => {
      if (driver.IDNO === action.payload.IDNO) {
       return { ...driver, ...action.payload };
      }
      return driver;
     });
    } else {
     drivers = [...state.drivers, action.payload];
    }
    return { ...state, drivers };
   case REMOVE_DRIVER:
    return {
     ...state,
     drivers: state.drivers.filter((driver) => driver.IDNO !== action.payload.IDNO),
    };
   case IS_SME:
    return { ...state, isSme: action.payload };
   case SET_VEHICLE_DETAILS:
    return { ...state, vehicleDetails: action.payload };
   case actions.UPDATE_CUSTOMER_DETAILS:
    const { personalDetails, customerDetails } = action.payload;
    return {
     ...state,
     personalFormDetails: personalDetails,
     customerDetails: customerDetails,
     isSme: personalDetails?.isSME,
    };
   case actions.CHANGE_DRIVER_REGISTERED:
    const { val, mobile } = action.payload;
    return {
     ...state,
     driverRegistered: { ...state.driverRegistered, isDriverRegistered: val, mobile: mobile },
    };
   case actions.CHANGE_DRIVER_SELECTED:
    return {
     ...state,
     driverRegistered: { ...state.driverRegistered, isDriverSelected: action.payload },
    };
   case SET_PAYMENT_METHOD:
    return { ...state, paymentMethod: action.payload };
   case UPDATE_VEHICLE_DETAILS:
    return {
     ...state,
     vehicles: action.payload,
    };
   case SET_POLICY_DETAILS:
    return {
     ...state,
     policyDetails: action.payload,
    };
   case SET_PROPOSAL_DETAILS:
    return {
     ...state,
     proposalDetails: action.payload,
    };
   case actions.GET_PROPOSAL_DETAILS:
    const proposals = action.payload?.data?.proposals;
    return { ...state, proposalDetails: proposals };
   case GET_VEHICLE_DETAILS:
    return {
     ...state,
     vehicles: [...state.vehicles, ...action.payload],
    };
   case UPDATE_SINGLE_VEHICLE_DETAILS:
    const vehiclesList = state.vehicles.filter(
     (vehicle) => vehicle.chassisNumber !== action.payload.chassisNumber
    );
    return {
     ...state,
     vehicles: [...vehiclesList, action.payload],
    };
   case REMOVE_VEHICLE:
    return {
     ...state,
     vehicles: state.vehicles.filter(
      (vehicle) => vehicle.chassisNumber !== action.payload.chassisNumber
     ),
    };
   case actions.SET_ACTIVE_PROGRAM:
    return { ...state, activeProgram: action.payload };
   case actions.SET_ACTIVE_VEHICLE:
    return { ...state, activeVehicle: action.payload };
   case actions.SET_VEHICLE_FEATURES:
    const carsFeatures = {
     ...state.carsFeatures,
     [state.activeVehicle]: {
      ...state.carsFeatures[state.activeVehicle],
      ...action.payload,
     },
    };
    const vehicles = state.vehicles.map((vehicle) => {
     if (vehicle.chassisNumber === state.activeVehicle) {
      const features = { selectedFeatures: [] };
      Object.keys(carsFeatures[state.activeVehicle]).forEach((key) => {
       features.selectedFeatures.push(carsFeatures[state.activeVehicle][key]);
      });
      vehicle.selectedFeatures = features;
     }
     return vehicle;
    });
    return { ...state, vehicles, carsFeatures };
   case actions.SET_TMX:
    return { ...state, tmx: action.payload };
   case actions.SET_TMX_VEHICLE_DETAILS:
    return { ...state, tmxVehicleDetails: action.payload };
   case actions.SAVE_QUOTATION_REQ_DATA:
    return { ...state, quotationData: action.payload };
    case actions.LEADGEN:
     return { ...state, isleadGeneratation: action.payload };
   case CHANGE_DEDUCTABLE:
    return { ...state, changeDeductable: state.changeDeductable + 1 };
   
   case RESET:
     return initialState;
   case actions.STORE_OTP:
      return { ...state, otp: action.payload };
   case actions.SAVE_TOTAL_PRICE:
      return { ...state, proposalPrice: action.payload };
   case actions.UPDATE_INCEPTION_DATE:
      return { ...state, leadInceptionDate: action.payload };
   default:
    return state;
  }
 }
 